export class Environment {
    public readonly tokenExpire: number;

    public readonly apiVersion: string;

    public readonly publicUrlPart: string;

    public readonly appVersion: string;

    public readonly production: boolean;

    public readonly debugToolbar: boolean;

    public constructor() {
        this.tokenExpire = Environment.getEnvNum('REACT_APP_TOKEN_EXPIRES');
        this.apiVersion = Environment.getEnv('REACT_APP_API_VERSION');
        this.publicUrlPart = Environment.getEnv('PUBLIC_URL');
        this.appVersion = Environment.getEnv('REACT_APP_VERSION');
        this.production = 'production' === process.env.NODE_ENV;
        this.debugToolbar = 'true' === Environment.getEnv('REACT_APP_SYMFONY_TOOLBAR');
    }

    private static getEnv(name: string): string {
        const envValue = process.env[name];
        if (undefined === envValue) {
            throw new Error(`${name} not defined`);
        }

        return envValue;
    }

    private static getEnvNum(name: string): number {
        // + converts to number type
        return +Environment.getEnv(name);
    }
}

export const environment = new Environment();
